/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CountryCodeEnum {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  An = 'AN',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  AuAct = 'AU_ACT',
  AuNsw = 'AU_NSW',
  AuNt = 'AU_NT',
  AuQld = 'AU_QLD',
  AuSa = 'AU_SA',
  AuTas = 'AU_TAS',
  AuVic = 'AU_VIC',
  AuWa = 'AU_WA',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  BqBo = 'BQ_BO',
  BqSa = 'BQ_SA',
  BqSe = 'BQ_SE',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  CaBc = 'CA_BC',
  CaQc = 'CA_QC',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  ChGr = 'CH_GR',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  CnXj = 'CN_XJ',
  Co = 'CO',
  Cq = 'CQ',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  EcW = 'EC_W',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  EsAr = 'ES_AR',
  EsCn = 'ES_CN',
  EsCt = 'ES_CT',
  EsGa = 'ES_GA',
  EsIb = 'ES_IB',
  EsMl = 'ES_ML',
  EsPv = 'ES_PV',
  Et = 'ET',
  EtAf = 'ET_AF',
  EtAm = 'ET_AM',
  EtBe = 'ET_BE',
  EtGa = 'ET_GA',
  EtHa = 'ET_HA',
  EtOr = 'ET_OR',
  EtSi = 'ET_SI',
  EtSn = 'ET_SN',
  EtSo = 'ET_SO',
  EtSw = 'ET_SW',
  EtTi = 'ET_TI',
  Eu = 'EU',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Fr20R = 'FR_20R',
  FrBre = 'FR_BRE',
  FrCp = 'FR_CP',
  Ga = 'GA',
  Gb = 'GB',
  GbCon = 'GB_CON',
  GbEng = 'GB_ENG',
  GbNir = 'GB_NIR',
  GbOrk = 'GB_ORK',
  GbSct = 'GB_SCT',
  GbWls = 'GB_WLS',
  Gd = 'GD',
  Ge = 'GE',
  GeAb = 'GE_AB',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  IdJb = 'ID_JB',
  IdJt = 'ID_JT',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  InAs = 'IN_AS',
  InGj = 'IN_GJ',
  InKa = 'IN_KA',
  InMn = 'IN_MN',
  InMz = 'IN_MZ',
  InOr = 'IN_OR',
  InTg = 'IN_TG',
  InTn = 'IN_TN',
  Io = 'IO',
  Iq = 'IQ',
  IqKr = 'IQ_KR',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  It21 = 'IT_21',
  It23 = 'IT_23',
  It25 = 'IT_25',
  It32 = 'IT_32',
  It34 = 'IT_34',
  It36 = 'IT_36',
  It42 = 'IT_42',
  It45 = 'IT_45',
  It52 = 'IT_52',
  It55 = 'IT_55',
  It57 = 'IT_57',
  It62 = 'IT_62',
  It65 = 'IT_65',
  It67 = 'IT_67',
  It72 = 'IT_72',
  It75 = 'IT_75',
  It77 = 'IT_77',
  It78 = 'IT_78',
  It82 = 'IT_82',
  It88 = 'IT_88',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  NlFr = 'NL_FR',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  PkJk = 'PK_JK',
  PkSd = 'PK_SD',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pt20 = 'PT_20',
  Pt30 = 'PT_30',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  RuBa = 'RU_BA',
  RuCe = 'RU_CE',
  RuCu = 'RU_CU',
  RuDa = 'RU_DA',
  RuDpr = 'RU_DPR',
  RuKo = 'RU_KO',
  RuLpr = 'RU_LPR',
  RuTa = 'RU_TA',
  RuUd = 'RU_UD',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  ShAc = 'SH_AC',
  ShHl = 'SH_HL',
  ShTa = 'SH_TA',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Un = 'UN',
  Us = 'US',
  UsAk = 'US_AK',
  UsAl = 'US_AL',
  UsAr = 'US_AR',
  UsAz = 'US_AZ',
  UsCa = 'US_CA',
  UsCo = 'US_CO',
  UsDc = 'US_DC',
  UsFl = 'US_FL',
  UsGa = 'US_GA',
  UsHi = 'US_HI',
  UsIn = 'US_IN',
  UsMd = 'US_MD',
  UsMo = 'US_MO',
  UsMs = 'US_MS',
  UsNc = 'US_NC',
  UsNm = 'US_NM',
  UsOr = 'US_OR',
  UsRi = 'US_RI',
  UsSc = 'US_SC',
  UsTn = 'US_TN',
  UsTx = 'US_TX',
  UsWa = 'US_WA',
  UsWi = 'US_WI',
  UsWy = 'US_WY',
  Um = 'UM',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xk = 'XK',
  Ye = 'YE',
  Yt = 'YT',
  Yu = 'YU',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}
